import React from 'react';
import PropTypes, {
  bool,
  number,
  func,
  string,
  shape
} from 'prop-types';
import { Col } from '@thd-olt-component-react/grid';
import { Quantity } from '@thd-olt-component-react/quantity';
import { AddToCart } from '@thd-olt-component-react/add-to-cart';
import { Fulfillment } from '@thd-olt-component-react/fulfillment';
import '../buybox.scss';

const BuyboxUnavailable = ({
  itemId,
  quantity,
  onFulfillmentChange,
  onDeliveryOptionsZipCodeChange,
  hideQuantity,
  onQuantityChange,
  quantityLimitExceed,
  directData
}) => {
  return (
    <Col fallback="12" data-component="BuyboxUnavailable">
      <div className="buybox-wrapper">
        <div className="buybox-top__wrapper">
          <div className="buybox__fulfillment-wrapper">
            <div className="buybox__fulfillment">
              <Fulfillment
                itemId={itemId}
                quantity={quantity}
                onChange={onFulfillmentChange}
                onDeliveryZipCodeChange={onDeliveryOptionsZipCodeChange}
                directData={directData}
              />
            </div>
          </div>
        </div>
        <div className="buybox__actions">
          {!hideQuantity && (
            <div className="buybox__quantity--wrapper">
              <Quantity
                value={quantity}
                onChange={onQuantityChange}
                className={quantityLimitExceed ? 'buybox__quantity--warning' : ''}
              />
            </div>
          )}
          <div className="buybox__atc--wrapper">
            <AddToCart disabled> Add to Cart </AddToCart>
          </div>

        </div>
        <div className="alert-inline alert-inline--danger">
          <span className="alert-inline__message">Unavailable combination. Please make another selection.</span>
        </div>
      </div>
    </Col>
  );
};

BuyboxUnavailable.propTypes = {
  itemId: string.isRequired,
  quantity: number,
  onFulfillmentChange: func,
  onDeliveryOptionsZipCodeChange: func,
  hideQuantity: bool,
  onQuantityChange: func,
  quantityLimitExceed: bool,
  /* eslint-disable-next-line react/forbid-prop-types */
  directData: PropTypes.objectOf(PropTypes.any)
};

BuyboxUnavailable.defaultProps = {
  quantity: 1,
  onFulfillmentChange: () => {},
  onDeliveryOptionsZipCodeChange: () => {},
  hideQuantity: false,
  onQuantityChange: () => {},
  quantityLimitExceed: false,
  directData: null
};

export { BuyboxUnavailable };